<template>
  <div class="hero-slider">
    <swiper ref="mySwiper" @slideChangeTransitionStart="slideChangeTransitionStart" @slideChangeTransitionEnd="slideChangeTransitionEnd" class="swiper" :options="swiperOption" v-if="slides.length">
      <swiper-slide class="swiper-item" v-for="(slide, i) in slides" :key="i">
        <HeroSliderItem
          block-name="banner"
          :position="i + 1"
          :slide-alt="slide.slide_alt"
          :slide-img="slide.slide_img"
          :slide-mob-img="slide.slide_mob_img"
          :slide-webp="slide.slide_webp"
          :slide-mob-webp="slide.slide_mob_webp"
          :slide-url="slide.slide_url"
          :slide-id="slide.slide_id"
        />
      </swiper-slide>
    </swiper>
    <div class="hero-slider__navigation">
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="hero-slider__pagination">
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import HeroSliderItem from './HeroSliderItem'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'HeroSlider',
  components: {
    HeroSliderItem,
    Swiper,
    SwiperSlide
  },
  computed: {
    ...mapState({
      slides: state => state.init.config.bannerSlides
    }),
    ...mapGetters(['isShowedSkeletons']),
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  data () {
    return {
      swiperOption: {
        preloadImages: false,
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    slideChangeTransitionStart () {
      let $wrapperEl = this.swiper.$wrapperEl
      let params = this.swiper.params
      $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
        .each(function () {
          let idx = this.getAttribute('data-swiper-slide-index')
          this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html()
        })
    },
    slideChangeTransitionEnd () {
      setTimeout(() => {
        this.swiper.slideToLoop(this.swiper.realIndex, 0, false)
      }, 0)
    }
  }
}
</script>

<style scoped lang="sass">

@import "../../styles/swiper/swiper"

.skeleton-desktop
  display: none

  +mmin($tablet--hor)
    display: block

.skeleton-mobile
  display: block

  +mmin($tablet--hor)
    display: none

.hero-slider
  position: relative
  min-height: 55.7vw
  +mmin($tablet--hor)
    min-height: 26.7vw

.hero-slider__navigation
  display: none
  position: absolute
  top: 50%
  left: 60px
  right: 60px
  transform: translateY(-50%)
  z-index: 1

  +mmin($tablet--hor)
    display: block

.hero-slider__pagination ::v-deep
  width: 100%
  position: absolute
  bottom: 12px
  z-index: 1

  +mmin($tablet--hor)
    bottom: 20px

  .swiper-pagination
    position: static

  .swiper-pagination-bullet
    background: $white-text-color
    opacity: .4

    &:not(:last-child)
      margin-right: 5px

      +mmin($tablet--hor)
        margin-right: 10px

  .swiper-pagination-bullet-active
    opacity: 1

</style>
